/**
* Functionality for the header navigation
*/
export default function headerNav ($) {
	let navToggle = document.getElementById('nav-toggle');
	// add accesiblity to divs. This function allows the enter key to activate the elements click function when focused upon
	
	document.onkeydown = function(e) {
		if(e.keyCode === 13) { // The Enter/Return key
			document.activeElement.click();
		}
	};
	
	if (navToggle) {
		navToggle.onclick = function () {
			console.log("there is a nav toggle");
			document.querySelector("body").classList.toggle('header-wrap--open');
		}
	}
	
	$('.b-search').click(function(e) {
		console.log('b serach pressed')
		e.stopPropagation();
		$('#search-field').removeClass('hide-field');	
		$('.header-nav').addClass('lighten');

		var shiftFocus = function (){
			$('#search-field').focus();
		}
		setTimeout(shiftFocus, 500)
			
		
	});
	$("body").click(function(e){
		if( e.target.id == "search-field"){
			e.stopPropagation();

		}else{
			$('#search-field').addClass('hide-field');
			$('.header-nav').removeClass('lighten');
	
		}
	}
	);

	// Header should hide on scroll down and show on scroll up
	if (!$('body').hasClass("single-cs-show")){

		let headerHeight = $('.header').height() + 150;	
		// Measure scroll from bottom of header to start
		let relativeScroll = headerHeight;

		$(window).scroll(function() {	
			let scrollDistance = $(this).scrollTop();	
			if ( scrollDistance > relativeScroll && scrollDistance > headerHeight){
				$('.header').removeClass('show-header');
				$('.header').addClass('hide-header');
			} 
			else{
				$('.header').removeClass('hide-header');
				$('.header').addClass('show-header');
			}	
			// Reset relative scroll to current scroll distance to determine if next scroll is up or down from there
			relativeScroll = scrollDistance;		
		});
	}
}






